import { FunctionComponent, useCallback, useContext, useState } from 'react'

import translate from '@i18n'
import APIContext from '@contexts/commenting/apiContext'

import CommentingActionPopup from './CommentingActionPopup'
import CommentingConfirmationMessage from './CommentingConfirmationMessage'
import CommentingItemWrappper from './CommentingItemWrapper'
import PostedCommentingItem from './PostedCommentingItem'
import { PostedCommentProps } from './types'
import { getTitle } from './utils'

const PostedComment: FunctionComponent<PostedCommentProps> = ({
  comment: {
    id,
    author_type,
    created,
    body,
    user: { first_name, last_name, gender },
  },
}) => {
  const { deletePostedComment } = useContext(APIContext)

  const [deletingComment, setDeletingComment] = useState(false)
  const [confirmationMessageShown, setConfirmationMessageShown] = useState(true)

  const onCommentingConfirmationMessageTimeout = useCallback(() => {
    setConfirmationMessageShown(false)
  }, [])

  return (
    <CommentingItemWrappper type="comment" itemId={id}>
      <PostedCommentingItem
        type="comment"
        authorType={author_type}
        gender={gender}
        deleting={deletingComment}
        authorName={getTitle({
          name: `${first_name} ${last_name}`,
        })}
        datePublished={created}
        textContent={body}
        onDelete={() => setDeletingComment(true)}
      />
      {confirmationMessageShown && (
        <CommentingConfirmationMessage
          onTimeout={onCommentingConfirmationMessageTimeout}
        >
          {translate('commenting.postCommentSentMessage')}
        </CommentingConfirmationMessage>
      )}
      {deletingComment && (
        <CommentingActionPopup
          type="comment"
          actionType="delete"
          onConfirm={() => {
            setDeletingComment(false)
            deletePostedComment({ commentId: id })
          }}
          onCancel={() => setDeletingComment(false)}
        />
      )}
    </CommentingItemWrappper>
  )
}

export default PostedComment
